import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintenanceManGetDeviceInfoBySn
    (id) {
    return maintainRequest.get(`/device/maintenanceMan/chargingPile/getDeviceInfoBySn/${id}`)
}
